<h3 class="marine-insurance-beneficiary-note">{{ "EDIT_BENEFICIARY_HINT" | translate }}</h3>

<div
  class="marine-insurance-beneficiary-item"
  [ngClass]="{ 'is-selected': formGroup.get('beneficiaryItemType').value === beneficiaryItem.entityCode }"
  *ngFor="let beneficiaryItem of beneficiaryItems"
>
  <div class="marine-insurance-beneficiary-item-header">
    <app-radio-button
      [control]="formGroup.get('beneficiaryItemType')"
      [id]="'beneficiaryItem-' + beneficiaryItem.entityCode"
      [label]="beneficiaryItem.label"
      [value]="beneficiaryItem.entityCode"
      [name]="'beneficiaryItem-type'"
    ></app-radio-button>
  </div>
  <div class="marine-insurance-beneficiary-item-body" *ngIf="formGroup.get('beneficiaryItemType').value === beneficiaryItem.entityCode">
    <app-marine-insurance-beneficiary-view-data
      [beneficiary]="entityData"
      [isShowPhone]="!!entityData?.phone"
      [isShowEmail]="!!entityData?.email"
    ></app-marine-insurance-beneficiary-view-data>

    <ng-container *ngIf="beneficiaryItem.isWithPhone">
      <app-control-wrapper [control]="entityFormGroup.get('email')" [isShowHelper]="false" *ngIf="!entityData?.email">
        <label for="email" control-label>{{ "FORM_LABEL.EMAIL_SHORT" | translate }}</label>

        <input
          id="email"
          class="form-control"
          type="text"
          control-wrapper
          [formControl]="entityFormGroup.get('email')"
          [mask]="'F*'"
          [patterns]="CUSTOM_MASK"
          [dropSpecialCharacters]="false"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        />
      </app-control-wrapper>

      <input-phone
        [fc]="entityFormGroup.get('phone')"
        [errors]="errorsPhone"
        [label]="'LABELS.PHONE'"
        [id]="'phone'"
        *ngIf="!entityData?.phone"
      ></input-phone>
    </ng-container>
  </div>
</div>

<section class="marine-insurance-beneficiary-footer">
  <button type="submit" class="btn btn-primary" [disabled]="isSaving" (click)="onSave()">
    {{ "BUTTON.SAVE" | translate }}
  </button>
</section>

<loading-spinner [show]="isSaving"></loading-spinner>
